import { render, staticRenderFns } from "../vehicle/vehicle.html?vue&type=template&id=97a83e74&scoped=true&external"
import script from "../vehicle/vehicle.js?vue&type=script&lang=js&external"
export * from "../vehicle/vehicle.js?vue&type=script&lang=js&external"
import style0 from "../vehicle/vehicle.css?vue&type=style&index=0&id=97a83e74&prod&scoped=true&lang=css&external"
import style1 from "./Vehicle.vue?vue&type=style&index=1&id=97a83e74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a83e74",
  null
  
)

export default component.exports